import { Component } from "react";
import { RefreshCw, Home } from "lucide-react";

const TXT = {
  de: { title: "Da ist etwas schiefgelaufen", body: "Die Seite konnte nicht angezeigt werden. Lade sie neu oder geh zurück zum Dashboard.", reload: "Neu laden", home: "Zum Dashboard" },
  en: { title: "Something went wrong", body: "This page could not be displayed. Reload it or go back to the dashboard.", reload: "Reload", home: "To dashboard" },
  fr: { title: "Un problème est survenu", body: "Cette page n'a pas pu s'afficher. Recharge-la ou reviens au tableau de bord.", reload: "Recharger", home: "Tableau de bord" },
  it: { title: "Qualcosa è andato storto", body: "La pagina non può essere mostrata. Ricaricala o torna alla dashboard.", reload: "Ricarica", home: "Alla dashboard" },
};
const lang = () => { try { return (localStorage.getItem("solano_lang") || navigator.language || "de").slice(0, 2); } catch { return "de"; } };

/** Catches render crashes so the user sees a message instead of a blank screen. */
export class AppErrorBoundary extends Component {
  state = { error: null };
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) { console.error("[AppErrorBoundary]", error, info?.componentStack); }
  componentDidUpdate(prev) {
    if (this.state.error && prev.pathname !== this.props.pathname) this.setState({ error: null });
  }
  render() {
    if (!this.state.error) return this.props.children;
    const t = TXT[lang()] || TXT.de;
    return (
      <div className="min-h-screen flex items-center justify-center px-6 bg-[#FAF7EF] dark:bg-slate-950" data-testid="app-error-boundary">
        <div className="max-w-sm w-full rounded-3xl bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 p-6 text-center shadow-sm">
          <h1 className="font-heading text-xl font-semibold text-[#1A1D1E] dark:text-white">{t.title}</h1>
          <p className="mt-2 text-sm text-slate-600 dark:text-slate-300">{t.body}</p>
          <p className="mt-2 text-[10px] text-slate-400 break-words" data-testid="app-error-detail">{String(this.state.error?.message || this.state.error).slice(0, 160)}</p>
          <div className="mt-5 flex flex-col gap-2">
            <button type="button" onClick={() => window.location.reload()} data-testid="app-error-reload"
              className="h-11 rounded-full bg-[#2C5254] text-white text-sm font-bold flex items-center justify-center gap-2 active:scale-95 transition">
              <RefreshCw className="h-4 w-4" /> {t.reload}
            </button>
            <button type="button" onClick={() => { window.location.href = "/app"; }} data-testid="app-error-home"
              className="h-11 rounded-full border border-slate-200 dark:border-slate-700 text-sm font-semibold text-slate-700 dark:text-slate-200 flex items-center justify-center gap-2 active:scale-95 transition">
              <Home className="h-4 w-4" /> {t.home}
            </button>
          </div>
        </div>
      </div>
    );
  }
}
